import { GET_LOCALE_INFO, SET_LOCALE, FETCH_MESSAGES, FETCH_MESSAGES_SUCCESS } from "./index";

export const getLocaleInfo = () => ({
  type: GET_LOCALE_INFO,
});

export const setLocale = (locale) => ({
  type: SET_LOCALE,
  locale,
});

export const fetchMessages = (locale) => ({
  type: FETCH_MESSAGES,
  locale,
});

export const fetchMessagesSuccess = (locale, messages) => ({
  type: FETCH_MESSAGES_SUCCESS,
  locale,
  messages,
});
